import React, { useEffect, useState } from "react";
import { DataGrid } from "@mui/x-data-grid";
import TabPanel from "../../serviceList/Tabpanel/TabPanel";
import Box from "@mui/material/Box";
import { Chip } from "@mui/material";

const BookingDataGrid = ({ bookingList, setPagination }) => {
  function convertTo12HourFormat(timeString) {
    let [hours, minutes] = timeString.split(":").map(Number);
    const ampm = hours >= 12 ? "PM" : "AM";
    hours = hours % 12 || 12;
    return `${hours}:${minutes.toString().padStart(2, "0")} ${ampm}`;
  }

  const rows = bookingList?.map((booking) => ({
    id: booking.id,
    service_name: booking.service,
    phone: booking.phone,
    customer_name: booking.name,
    customer_address: booking.address,
    date: booking.booked_date,
    worker_name: booking.worker_name,
    time: convertTo12HourFormat(booking.booked_time),
    status: booking.status,
    booking_price: booking.booking_price,
    miscellaneous_price: booking.miscellaneous_price,
    payment_method: booking.payment_method,
    payable_amount: booking.payable_amount,
    service_charge: booking.service_charge,
    is_booked: booking.is_booked,
    is_paid: booking.is_paid,
    latitude: booking.latitude,
    longitude: booking.longitude,
    total_price: booking.total_price,
    miscellaneous_price_comment: booking.miscellaneous_price_comment,
    service_charge_comment: booking.service_charge_comment,
  }));

  const columns = [
    { field: "id", headerName: "ID", width: 90 },
    { field: "service_name", headerName: "Service Name", width: 150 },
    { field: "customer_name", headerName: "Customer Name", width: 150 },
    { field: "phone", headerName: "Customer Number", width: 150 },
    { field: "customer_address", headerName: "Customer Address", width: 170 },

    { field: "date", headerName: "Date", width: 150 },
    { field: "time", headerName: "Time", width: 110 },
    { field: "worker_name", headerName: "Worker", width: 150 },
    {
      field: "status",
      headerName: "Status",
      width: 150,
      renderCell: (params) => {
        let chipColor;

        switch (params.value) {
          case "Waiting":
            chipColor = "warning";
            break;
          case "Accepted":
            chipColor = "success";
            break;
          case "Cancelled":
            chipColor = "error";
            break;
          case "Estimated":
            chipColor = "primary";
            break;
          case "Completed":
            chipColor = "secondary";
            break;
          default:
            chipColor = "default";
        }

        return (
          <Chip
            label={params.value}
            color={chipColor}
            style={{
              color: "white",
              minWidth: "100px",
            }}
          />
        );
      },
    },
    {
      field: "is_booked",
      headerName: "Booking Status",
      width: 150,
      renderCell: (params) => (
        <Chip
          label={params.value ? "Booked" : "Not Booked"}
          style={{
            backgroundColor: params.value ? "green" : "red",
            color: "white",
            minWidth: "100px",
          }}
        />
      ),
    },
    {
      field: "is_paid",
      headerName: "Payment Status",
      width: 150,
      renderCell: (params) => (
        <Chip
          label={params.value ? "Paid" : "Not Paid"}
          style={{
            backgroundColor: params.value ? "green" : "red",
            color: "white",
            minWidth: "100px",
          }}
        />
      ),
    },
    { field: "payment_method", headerName: "Payment Method", width: 130 },
    { field: "booking_price", headerName: "Booking Price", width: 130 },
    {
      field: "miscellaneous_price",
      headerName: "Miscellaneous Price",
      width: 150,
    },
    {
      field: "service_charge",
      headerName: "Service Charge",
      width: 150,
    },
    {
      field: "total_price",
      headerName: "Total Price",
      width: 150,
    },
    {
      field: "payable_amount",
      headerName: "Payable Amount",
      width: 150,
    },

    {
      field: "miscellaneous_price_comment",
      headerName: "Miscellaneous Price Comment",
      width: 150,
    },
    {
      field: "service_charge_comment",
      headerName: "Service Charge Comment ",
      width: 150,
    },

    { field: "latitude", headerName: "Latitude", width: 150 },
    { field: "longitude", headerName: "Longitude", width: 150 },
    
  ];

  return (
    <div>
      <Box
        sx={{
          flexGrow: 1,
          maxWidth: { xs: 650, sm: 1000, lg: 1350 },
          bgcolor: "background.paper",
        }}
      >
        <TabPanel>
          <DataGrid
            rows={rows}
            columns={columns}
            pageSizeOptions={[10, 25, 50, 100]}
            initialState={{
              pagination: {
                paginationModel: {
                  pageSize: 25,
                },
              },
            }}
            disableSelectionOnClick
            onPaginationModelChange={setPagination}
          />
        </TabPanel>
      </Box>
    </div>
  );
};

export default BookingDataGrid;
